// extracted by mini-css-extract-plugin
export default {"price-page":"Index_price-page__e61Cj","price-page__info":"Index_price-page__info__PoQK4"};